import { useSelector } from "react-redux";

import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Grid } from "@mui/material";

export default function LitcoRadioField(props) {
  const {
    xs,
    sm,
    md,
    lg,
    xl,
    mt,
    mb,
    label,
    value,
    onChange,
    onChangeExtraParameters,
    options,
    required,
    labelSize,
    radioSize,
    invalid,
    disabled,
  } = props;

  const globalLoading = useSelector((state) => state.loading.active); //Fields are automatically disabled if API is in use

  let name;

  if (!props.name) {
    name = label.replaceAll(" ", "");
    name = name.charAt(0).toLowerCase() + name.substring(1);
  } else {
    name = props.name;
  }

  const generateRadioOptions = () => {
    const radioSx = { "& .MuiSvgIcon-root": { fontSize: radioSize } };

    if (!options) {
      return [
        <FormControlLabel value="no" key={name + "No"} control={<Radio />} label="No" sx={radioSx} />,
        <FormControlLabel value="yes" key={name + "Yes"} control={<Radio />} label="Yes" sx={radioSx} />,
      ];
    }

    const radioOptions = [];

    options.forEach((option) => {
      const radioValue = option.value ?? option.label.toLowerCase();

      radioOptions.push(
        <FormControlLabel
          value={radioValue}
          key={name + radioValue}
          control={<Radio />}
          label={option.label}
          sx={radioSx}
          disabled={disabled || globalLoading}
        />
      );
    });

    return radioOptions;
  };

  const field = (
    <FormControl required={required}>
      <FormLabel id={name} sx={{ fontSize: labelSize, color: invalid && "#fc0303" }}>
        {label}
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby={name}
        name={name}
        value={value}
        onChange={onChangeExtraParameters ? (event) => onChange(onChangeExtraParameters, event) : onChange}
      >
        {generateRadioOptions()}
      </RadioGroup>
    </FormControl>
  );

  if (xs || sm || md || lg || xl) {
    return (
      <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} mt={mt} mb={mb}>
        {field}
      </Grid>
    );
  } else {
    return field;
  }
}
